import styled from "@emotion/styled";

export const StyledCardContainer = styled.div`
  background-color: ${({ theme }) => theme.colors.surface.onboardingSubtle};
  border-radius: ${({ theme }) => theme.borderRadius.large};
  padding: ${({ theme }) => theme.spacing["4"]} ${({ theme }) => theme.spacing["3"]};
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing["3"]};
  width: 100%;
`;

export const StyledHeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing["2"]};
  width: 100%;
`;

export const StyledHeader = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  width: 100%;
`;

export const StyledHeaderTitle = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  font-size: ${({ theme }) => theme.fontSizes["text-xs"]};
  line-height: ${({ theme }) => theme.lineHeights["text-xs"]};
  font-weight: ${({ theme }) => theme.fontWeights.semiBold};
  color: ${({ theme }) => theme.colors.text.primary};
`;

export const StyledExpandButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${({ theme }) => theme.spacing["0"]};
  border-radius: ${({ theme }) => theme.borderRadius.max};
  width: 16px;
  height: 16px;
  background: transparent;
  border: none;
  cursor: pointer;
  flex-shrink: 0;

  &:hover {
    opacity: 0.8;
  }
`;

export const StyledProgressBarContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
`;

export const StyledStepsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing["0.5"]};
  padding: ${({ theme }) => theme.spacing["1"]} 0;
  width: 100%;
`;

export const StyledStepRow = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  width: 100%;
  gap: ${({ theme }) => theme.spacing["4"]};
`;

export const StyledStepContent = styled.div`
  display: flex;
  align-items: flex-start;
  flex: 1;
  min-width: 0;
`;

export const StyledStepTitle = styled.div<{ $isCompleted?: boolean }>`
  font-size: ${({ theme }) => theme.fontSizes["text-xs"]};
  line-height: ${({ theme }) => theme.lineHeights["text-xs"]};
  font-weight: ${({ theme }) => theme.fontWeights.regular};
  color: ${({ theme, $isCompleted }) =>
    $isCompleted ? theme.colors.text.secondary : theme.colors.text.primary};
  word-wrap: break-word;
  overflow-wrap: break-word;
  text-decoration: ${({ $isCompleted }) => ($isCompleted ? "line-through" : "none")};

  /* Help button is positioned inline at the end of text */
  display: inline;

  button {
    display: inline-flex;
    vertical-align: middle;
    margin-left: 4px;
  }
`;

export const StyledStepRightIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  margin-top: 0;
`;

export const StyledSeparatorWrapper = styled.div`
  width: 100%;
`;

export const StyledCompletionContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing["0.5"]};
  width: 100%;
`;

export const StyledCompletionMessage = styled.div`
  font-size: ${({ theme }) => theme.fontSizes["text-xs"]};
  line-height: ${({ theme }) => theme.lineHeights["text-xs"]};
  font-weight: ${({ theme }) => theme.fontWeights.regular};
  color: ${({ theme }) => theme.colors.text.primary};
  width: 100%;
`;

export const StyledExploreLink = styled.button`
  font-size: ${({ theme }) => theme.fontSizes["text-xs"]};
  line-height: ${({ theme }) => theme.lineHeights["text-xs"]};
  font-weight: ${({ theme }) => theme.fontWeights.semiBold};
  color: ${({ theme }) => theme.colors.text.emphasis};
  background: transparent;
  border: none;
  padding: 0;
  cursor: pointer;
  text-align: left;
  width: 100%;

  &:hover {
    opacity: 0.8;
  }
`;
